import QuestionContent from './components/question-content';
import { SurveyProvider } from './context/SurveyProvider';
import Survey from './question';

export default function QuestionsPage() {
	return (
		<SurveyProvider>
			<QuestionContent>
				<Survey />
			</QuestionContent>
		</SurveyProvider>
	);
}
